export const LOAD_ASSET_TYPES = "LOAD_ASSET_TYPES";
export const LOAD_ASSET_TYPES_SUCCESS = "LOAD_ASSET_TYPES_SUCCESS";
export const LOAD_ASSET_TYPES_ERROR = "LOAD_ASSET_TYPES_ERROR";
